import { faCheckCircle, faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const LoadingModal = ({ show, handleClose, success, loading, loging, mesas }) => {
  const history = useHistory();
  const successIcon = <FontAwesomeIcon icon={faCheckCircle} style={{ color: "#a5dc86", fontSize: 80, marginBottom: 20 }} />;

  const errorIcon = <FontAwesomeIcon icon={faTimesCircle} style={{ color: "#ff2e2e", fontSize: 80, marginBottom: 20 }} />;


  if (mesas) {
    const handleCancel = () => {
      return history.push("/home");
    };

    // const handleRedirect = () => {
    //   return history.push(`/gestion?grupo=${grupo}&tipo=inmuebles`);
    // };

    return (
      <Modal show={show} onHide={handleClose} backdrop="static" animation={false} centered>
        <Modal.Body className='mt-5'>
          {loading ? (
            <div className='d-flex flex-column justify-content-center align-items-center'>
              <Spinner animation="border" style={{ color: "#0477AD", width: 50, height: 50 }} />

              <h2 className='mt-3 mb-5'>Cargando...</h2>

              <Button className="" style={{ margin: 10 }} variant="danger" onClick={handleCancel}>Cancelar</Button>

              {/* <Button className="btn-outline" style={{ width: "75%", margin: 10 }} onClick={handleRedirect}>Redirigir a la pantalla de gestión legal.</Button> */}
            </div>
          ) : (
            <div className='d-flex flex-column justify-content-center align-items-center'>
              {success ? (
                <>
                  {successIcon}
                  <h2>Exito!</h2>
                </>
              ) : (
                <>
                  {errorIcon}
                  <h2>Error, intentelo de nuevo.</h2>
                </>
              )}
            </div>
          )}
        </Modal.Body>
        {!loading ? (
          <Modal.Footer className='d-flex justify-content-center'>
            <Button onClick={handleClose}>Aceptar</Button>
          </Modal.Footer>
        ) : null}
      </Modal>
    );

  }

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" animation={false} centered>
      <Modal.Body className='mt-5'>
        {loading ? (
          <div className='d-flex flex-column justify-content-center align-items-center'>
            <Spinner animation="border" style={{ color: "#0477AD", width: 50, height: 50 }} />
            {loging ? (
              <h2 className='mt-3 mb-5'>Iniciando sesión...</h2>
            ) : (
              <h2 className='mt-3 mb-5'>Cargando...</h2>
            )}
          </div>
        ) : (
          <div className='d-flex flex-column justify-content-center align-items-center'>
            {success ? (
              <>
                {successIcon}
                <h2>Exito!</h2>
              </>
            ) : (
              <>
                {errorIcon}
                <h2>Error, intentelo de nuevo.</h2>
              </>
            )}
          </div>
        )}
      </Modal.Body>
      {!loading ? (
        <Modal.Footer className='d-flex justify-content-center'>
          <Button onClick={handleClose}>Aceptar</Button>
        </Modal.Footer>
      ) : null}
    </Modal>
  );
};

export default LoadingModal;